import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, h } from "vue";
import { useI18n } from "vue-i18n";
import { Checkbox, DataTable } from "@eudonet/opal";
const CHANNEL_COL_WIDTH = 140;
const PURPOSE_COL_WIDTH = 240;
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConsentMatrixGrid',
    props: {
        entries: {},
        channels: {},
        purposes: {},
        purposeLabels: {}
    },
    emits: ["toggle"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        // null = no matrix cell for this pair (e.g. a tracking purpose on SMS): not applicable, not "off".
        function cellState(channel, purpose) {
            return props.entries.find((e) => e.channelType === channel && e.purpose === purpose)?.isEnabled ?? null;
        }
        const rows = computed(() => props.purposes.map((purpose) => ({
            purpose,
            values: Object.fromEntries(props.channels.map((channel) => [channel, cellState(channel, purpose)])),
        })));
        // Narrow channel columns (checkbox-only) so the named columns fit common
        // settings-page widths without triggering DataTable's overflow-x-auto scroll.
        // Stretcher column absorbs leftover space on wider viewports.
        function getPurposeLabel(purpose) {
            return props.purposeLabels[purpose.toLowerCase()] ?? t(`consent.matrix.purpose.${purpose.toLowerCase()}`);
        }
        const columns = computed(() => {
            const purposeColumn = {
                id: "purpose",
                header: t("consent.matrix.column.purpose"),
                width: PURPOSE_COL_WIDTH,
                cell: ({ row }) => getPurposeLabel(row.original.purpose),
            };
            const channelColumns = props.channels.map((channel) => ({
                id: channel,
                header: t(`consent.matrix.channel.${channel.toLowerCase()}`),
                width: CHANNEL_COL_WIDTH,
                cell: ({ row }) => h(Checkbox, {
                    modelValue: row.original.values[channel] ?? false,
                    disabled: row.original.values[channel] == null,
                    "data-testid": `toggle-${channel}-${row.original.purpose}`,
                    ariaLabel: t("consent.matrix.toggleAria", {
                        channel: t(`consent.matrix.channel.${channel.toLowerCase()}`),
                        purpose: getPurposeLabel(row.original.purpose),
                    }),
                    "onUpdate:modelValue": () => emit("toggle", channel, row.original.purpose),
                }),
            }));
            return [purposeColumn, ...channelColumns];
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(DataTable), {
                columns: columns.value,
                data: rows.value
            }, null, 8 /* PROPS */, ["columns", "data"]));
        };
    }
});
